import {Action, createAction, props} from '@ngrx/store'
import {DaneZgloszeniaZapytanie} from '../../services/samoobsluga/types/dane-zgloszenia-zapytanie';
import {Samoobsluga} from '../../services/samoobsluga/types/samoobsluga';
import {SamoobslugaActions} from './samoobsluga-action-type';

export const zaktualizujToken = createAction(SamoobslugaActions.ZAKTUALIZUJ_TOKEN, props<{ token: string }>())
export const pobierzDaneZgloszenia = createAction(SamoobslugaActions.POBIERZ_DANE_ZGLOSZENIA,
  props<{ daneZgloszeniaZapytanie: DaneZgloszeniaZapytanie, nastepnaAkcja: (samoobsluga: Samoobsluga) => Action }>())
export const zaktualizujStan = createAction(SamoobslugaActions.ZAKTUALIZUJ_STAN, props<{ stanSamoobslugi: string }>())
